import React from "react";
import { useParams } from "react-router";
import Query from "../../components/Query";
import ReactMarkdown from "react-markdown";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import Copyright from "../../components/Copyright";
import {
  smallestImageURLForRecord,
  downloadLinkDetails,
} from "../../utils/recordUtils";
import PlainText from "../../components/PlainText";
import RECORD_QUERY from "../../queries/records/record";

const Record = (props) => {
  let { id } = useParams();

  return (
    <Query query={RECORD_QUERY} id={id}>
      {({ data: { record } }) => {
        const imageUrl = smallestImageURLForRecord(record);
        console.log("record: ", record);
        const {
          transcribers,
          copyrights,
          projects,
          references,
          locations,
          subjects,
          dimension,
          objetdarts,
          metadata,
          people,
          digitised_page,
          downloads,
          image,
          periods,
        } = record;
        return (
          <>
            <div className="uk-container uk-container-center uk-margin-top uk-margin-large-bottom">
              <div uk-grid="true" data-uk-grid-margin="true">
                <div className="uk-width-medium-3-4 uk-row-first">
                  <article className="uk-article animation: uk-animation-fade">
                    <h1 className="uk-article-title">
                      {record.title || record.name}
                    </h1>
                    <hr></hr>
                    <div className="uk-section">
                      <div className="uk-container uk-container-small">
                        <div className="uk-panel">
                          <Link to={`/imageview/${id}`}>
                            <img
                              src={imageUrl}
                              alt={imageUrl}
                              className="uk-height-small uk-align-left uk-margin-remove-adjacent"
                            />
                          </Link>

                          <PlainText source={record.description} />
                        </div>
                        <hr></hr>
                        <h4 className="uk-h2">Transcription</h4>
                        <hr></hr>
                        <div>
                          <PlainText source={record.transcription} />
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
                <div className="uk-width-medium-1-4 animation: uk-animation-fade">
                  <div className="uk-panel uk-panel-box uk-text-center">
                    <h4>Transcribed by</h4>
                    {transcribers &&
                      transcribers.map((transcriber, i) => {
                        return (
                          <Link
                            to={{
                              pathname: `/records`,
                              state: {
                                search: transcriber.name,
                                type: "transcribers",
                              },
                            }}
                            key={i}
                          >
                            <img
                              className="uk-border-circle"
                              width="120"
                              height="120"
                              src={
                                transcriber.avatar
                                  ? downloadLinkDetails(transcriber.avatar.url)
                                  : "data:image/svg+xml;base64,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"
                              }
                              alt=""
                            />
                            <h3>{transcriber.name}</h3>
                          </Link>
                        );
                      })}
                    {(!transcribers || transcribers.length === 0) && (
                      <h3>--</h3>
                    )}
                  </div>
                  <div className="uk-panel uk-margin-top">
                    <h3 className="uk-panel-title">Record Details</h3>
                    <ul className="uk-list uk-list-line">
                      <li>
                        Scran id: <br />
                        <Link
                          to={{
                            pathname: `/records`,
                            state: {
                              search: record.scran_id,
                              type: "scran_id",
                            },
                          }}
                        >
                          {record.scran_id}
                        </Link>
                      </li>
                      <li>
                        Image Copyright:
                        <br />
                        {copyrights.map((copyright, i) => (
                          <Link
                            to={{
                              pathname: `/records`,
                              state: {
                                search: copyright.name,
                                type: "copyrights",
                              },
                            }}
                            key={i}
                          >
                            {copyright.name}
                          </Link>
                        ))}
                      </li>
                      <li>
                        Projects:
                        <br />
                        {projects.map((project, i) => (
                          <Link
                            to={{
                              pathname: `/records`,
                              state: {
                                search: project.name,
                                type: "projects",
                              },
                            }}
                            key={i}
                          >
                            {project.name}
                          </Link>
                        ))}
                      </li>
                      <li>
                        Digitised inventory:
                        <br />
                        {digitised_page && (
                          <Link
                            to={{
                              pathname: `/digitised_inventory/${digitised_page.id}`,
                            }}
                          >
                            {digitised_page.title}
                          </Link>
                        )}
                      </li>
                      <li>
                        Refs:
                        <br />
                        {references.map((reference, i) => (
                          <Link
                            to={{
                              pathname: `/records`,
                              state: {
                                search: reference.name,
                                type: "references",
                              },
                            }}
                            key={i}
                          >
                            {reference.name}
                          </Link>
                        ))}
                      </li>
                      <li>
                        Subjects:
                        <br />
                        {subjects.map((s, i) => (
                          <Link
                            to={{
                              pathname: `/records`,
                              state: {
                                search: s.name,
                                type: "subjects",
                              },
                            }}
                            key={i}
                          >
                            {s.name}
                            <br />
                          </Link>
                        ))}
                      </li>
                      <li>
                        Locations:
                        <br />
                        {locations.map((s, i) => (
                          <Link
                            to={{
                              pathname: `/records`,
                              state: {
                                search: s.name,
                                type: "locations",
                              },
                            }}
                            key={i}
                          >
                            {s.name}
                            <br />
                          </Link>
                        ))}
                      </li>
                      <li>
                        People:
                        <br />
                        {people.map((s, i) => (
                          <Link
                            to={{
                              pathname: `/people/${s.id}`,
                            }}
                            key={i}
                          >
                            {s.name}
                            <br />
                          </Link>
                        ))}
                      </li>
                      <li>
                        Periods:
                        <br />
                        {periods.map((s, i) => (
                          <Link
                            to={{
                              pathname: `/records`,
                              state: {
                                search: s.date,
                                type: "periods",
                              },
                            }}
                            key={i}
                          >
                            {s.date}
                            <br />
                          </Link>
                        ))}
                      </li>
                      <li>
                        Objet D'art:
                        <br />
                        {objetdarts.map((s, i) => (
                          <Link to={`/item/${s.id}`} key={i}>
                            {s.name}
                            <br />
                          </Link>
                        ))}
                      </li>
                      <li>
                        Dimension:
                        <br />
                        {dimension && dimension.Dimension !== undefined && (
                          <Link
                            to={{
                              pathname: `/records`,
                              state: {
                                search: dimension.Dimension,
                                type: "dimension",
                              },
                            }}
                          >
                            {dimension.Dimension}
                          </Link>
                        )}
                        {dimension &&
                          !dimension.Dimension &&
                          dimension.length > 0 &&
                          dimension.map((s, i) => (
                            <Link
                              to={{
                                pathname: `/records`,
                                state: {
                                  search: s.name,
                                  type: "dimension",
                                },
                              }}
                              key={i}
                            >
                              {s.name}
                              <br />
                            </Link>
                          ))}
                      </li>
                      <li>
                        Downloads:
                        <br />
                        {downloads &&
                          downloads.map((s, i) => (
                            <a
                              href={downloadLinkDetails(s.url)}
                              target="_"
                              key={i}
                            >
                              {s.name}
                              <br />
                            </a>
                          ))}
                        {image && (
                          <a href={downloadLinkDetails(image.url)} target="_">
                            Original Image
                            <br />
                          </a>
                        )}
                      </li>
                      <li>
                        <small>
                          Metadata: <br />
                          {metadata && JSON.stringify(metadata, null, 2)}
                        </small>
                      </li>
                      <li>
                        <small>
                          Record id: <br />
                          {record.id}
                        </small>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="uk-section uk-position-bottom-center uk-position-relative">
                {Copyright()}
              </div>
            </div>
          </>
        );
      }}
    </Query>
  );
};

export default Record;
